// extracted by mini-css-extract-plugin
export var formContainer = "_bz-0";
export var message = "_bz-1";